import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import FundsBg from "@/assets/img/mms/funds-bg.webp";
import { rem2px } from "@/utils/fontSize";
const ProportionMaterialFunds = ({ className = "", }) => {
    const chartRef = useRef(null);
    const resizeObserverRef = useRef(null);
    // 图表数据
    const ringData = [
        { value: 12345, name: "30天", percent: "20%", color: "#71E2F3" },
        { value: 13512, name: "60天", percent: "30%", color: "#4A97F4" },
        { value: 27913, name: "180天", percent: "40%", color: "#62D7A5" },
        { value: 10913, name: "360天", percent: "10%", color: "#F6A624" },
    ];
    // 图表配置项
    const getOption = () => ({
        backgroundColor: "transparent",
        color: ringData.map(item => item.color),
        tooltip: {
            trigger: "item",
            formatter: "{b}: {c} ({d}%)",
            backgroundColor: "rgba(6, 32, 66, 0.8)",
            borderColor: "#36A8D9",
            borderWidth: 1,
            textStyle: {
                color: "#FFFFFF",
                fontSize: rem2px(0.13),
            },
            borderRadius: 4,
        },
        legend: {
            orient: "vertical",
            right: rem2px(0.1),
            top: "center",
            transform: "translateY(-50%)",
            itemWidth: rem2px(0.2),
            itemHeight: rem2px(0.2),
            itemGap: rem2px(0.2),
            icon: "circle",
            textStyle: {
                color: "#FFFFFF",
                fontSize: rem2px(0.13),
            },
            formatter: (name) => {
                const item = ringData.find(i => i.name === name);
                return `${name}  ${item?.value || ""}  ${item?.percent || ""}`;
            },
        },
        series: [
            {
                name: "出入库情况",
                type: "pie",
                radius: ["45%", "66%"],
                center: ["25%", "50%"],
                avoidLabelOverlap: false,
                label: { show: false },
                labelLine: { show: false },
                itemStyle: {
                    borderWidth: rem2px(0.04),
                    borderColor: "#071F4A",
                },
                data: ringData.map(item => ({
                    value: item.value,
                    name: item.name,
                    itemStyle: { color: item.color },
                })),
            },
        ],
    });
    // 处理图表尺寸调整
    useEffect(() => {
        let resizeTimer;
        // 防抖处理的 resize 方法
        const handleResize = () => {
            const chartInstance = chartRef.current?.getEchartsInstance();
            chartInstance?.resize();
        };
        const debouncedResize = () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(handleResize, 100);
        };
        // 监听窗口 resize
        window.addEventListener("resize", debouncedResize);
        // 监听父容器尺寸变化
        const setupObserver = () => {
            const chartInstance = chartRef.current?.getEchartsInstance();
            if (!chartInstance)
                return;
            const chartDom = chartInstance.getDom();
            const parentElement = chartDom.parentElement;
            if (!parentElement)
                return;
            resizeObserverRef.current = new ResizeObserver(entries => {
                if (entries.length) {
                    requestAnimationFrame(debouncedResize);
                }
            });
            resizeObserverRef.current.observe(parentElement);
        };
        // 初始化时执行一次
        setupObserver();
        handleResize();
        // 清理函数
        return () => {
            window.removeEventListener("resize", debouncedResize);
            resizeObserverRef.current?.disconnect();
            clearTimeout(resizeTimer);
        };
    }, []);
    return (_jsxs("div", { className: `relative bg-gradient-to-tr from-[#071F4A] to-[#0f295300] flex flex-col ${className} min-h-0`, children: [_jsx(ModuleHeader, { title: "\u7269\u8D44\u5E93\u5B58\u91D1\u989D\u5360\u6BD4" }), _jsx("div", { className: "flex-1 min-h-0 p-[0.1rem]", children: _jsx(ReactEcharts, { ref: chartRef, option: getOption(), style: { width: "100%", height: "100%" }, opts: { renderer: "canvas" } }) }), _jsx("img", { src: FundsBg, alt: "\u80CC\u666F\u56FE", style: {
                    position: "absolute",
                    left: "26.5%",
                    top: "57.5%",
                    transform: "translate(-50%, -50%)",
                    width: "2.11rem",
                    height: "2.10rem",
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                } })] }));
};
export default ProportionMaterialFunds;
